import React from "react";
import {PropTypes} from "prop-types";

import copy from "../copy";
import {Input} from "../../components/input";

export function OtherIncomeSourceField(props) {
    return (
        <Input
            {...copy.other_income_source}
            autoValidateAndFormat
            maxLength={50}
            type="text"
            {...props}
            onBlur={props.onChange}
        />
    );
}

OtherIncomeSourceField.propTypes = {
    value: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string,
};
